import React from 'react';
import PropTypes from 'prop-types';
import { getNodes } from '../utils/contentful';
import Layout from '../components/Layout';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/base.scss';

DefaultLayout.propTypes = {
  data: PropTypes.shape({}).isRequired,
  children: PropTypes.func,
};

export default function DefaultLayout({ data, children }) {
  return (
    <Layout
      Header={Header}
      Footer={Footer}
      pages={getNodes(data.pages)}
    >
      {children()}
    </Layout>
  );
}

export const pageQuery = graphql`
  query DefaultLayoutQuery {
    pages: allContentfulPage(limit: 1000) {
      edges {
        node {
          id
          title
          slug
          subpages {
            id
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js